import { useRef, useEffect, useState } from "react";
import GetIcon from "../../../../../utils/Icon";
import { handleDownloadCSV } from "../../../../../utils/CsvDownload";
import Pagination from "../../../../../Components/Pagination";
import Button from "../../../../../Core/Button/Button";
import EditItemModal from "./EditItemModal";

const EnhancedTable = ({ setselected_item_data, list_data, setRows, rows, fullData }) => {
  const createNewRow = () => ({
    item_code: "",
    item: {},
    required_by: "",
    quantity: "1",
    uom: "",
    rate: "0",
    amount: "0",
  });
  console.log(rows, "rows123123");



  const tableRef = useRef();
  const dropdownRef = useRef();
  const quantityInputRefs = useRef([]);
  const rateInputRefs = useRef([]);
  const [offset, setOffset] = useState(0);
  const [item_list, setitem_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [rowsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(null);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const [showEditModal, setShowEditModal] = useState(false);
  const [popdata, setpopdata] = useState();
  const [dropdownRowIndex, setDropdownRowIndex] = useState(null);

  const openEditModal = (row, index) => {
    setShowEditModal(true);
    setpopdata({ ...row, index });
  };

  // Update input refs when rows change
  useEffect(() => {
    quantityInputRefs.current = quantityInputRefs.current.slice(0, rows.length);
    rateInputRefs.current = rateInputRefs.current.slice(0, rows.length);
  }, [rows]);

  // Update amount when quantity or rate changes
  useEffect(() => {
    const updatedRows = rows.map(row => {
      const quantity = parseFloat(row.quantity) || 0;
      const rate = parseFloat(row.rate) || 0;
      return {
        ...row,
        amount: (quantity * rate).toFixed(0)
      };
    });
    setRows(updatedRows);
    setselected_item_data(updatedRows);
    setitem_list([])
  }, [rows.map(row => `${row.quantity}-${row.rate}`).join()]);

  // Keyboard navigation handler for inputs
  const handleInputKeyDown = (e, rowIndex, field, refs) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const nextRowIndex = rowIndex + 1;
      if (nextRowIndex < rows.length) {
        const nextInput = refs.current[nextRowIndex];
        if (nextInput) {
          nextInput.focus();
          nextInput.select();
          setActiveIndex(nextRowIndex);
        }
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prevRowIndex = rowIndex - 1;
      if (prevRowIndex >= 0) {
        const prevInput = refs.current[prevRowIndex];
        if (prevInput) {
          prevInput.focus();
          prevInput.select();
          setActiveIndex(prevRowIndex);
        }
      }
    } else if (e.key === 'Tab') {
      e.preventDefault();
      if (field === 'quantity') {
        const rateInput = rateInputRefs.current[rowIndex];
        if (rateInput) {
          rateInput.focus();
          rateInput.select();
          setFocusedCell({ rowIndex, field: 'rate' });
        }
      }
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Only select rows in the current page
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => [...new Set([...prev, ...pageRowIndices])]);
    } else {
      // Deselect only the current page rows
      const pageRowIndices = rows
        .map((_, index) => index)
        .slice(indexOfFirstRow, indexOfLastRow);

      setSelectedRows((prev) => prev.filter((i) => !pageRowIndices.includes(i)));
    }
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  // Fix: Check if all rows in current page are selected
  const isAllSelected = currentRows.length > 0 &&
    currentRows.every((_, index) => selectedRows.includes(indexOfFirstRow + index));

  const getItemdata = async (newOffset = 0, searchText = "") => {
    const res = await list_data({ start: newOffset, search_input: searchText, disabled: 0,productlist:rows.map(d => d.item.item_code) });
    const products = res?.data?.result?.products || [];
    if (newOffset === 0) {
      setitem_list(products);
    } else {
      setitem_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 20);
  };

  // const updateRow = (index, field, value) => {
  //   const updatedRows = [...rows];
  //   updatedRows[index][field] = value;

  //   // If updating quantity or rate, recalculate amount
  //   if (field === "quantity" || field === "rate") {
  //     const quantity = parseFloat(updatedRows[index].quantity) || 0;
  //     const rate = parseFloat(updatedRows[index].rate) || 0;
  //     updatedRows[index].amount = (quantity * rate).toFixed(0);
  //   }

  //   setRows(updatedRows);
  //   setselected_item_data(updatedRows);
  // };


  
const updateRow = (index, field, value) => {

  let updatedRow;
  if (field === "item") {
    updatedRow = {
      ...rows[index],
      item: value,
      item_code: value.item_code,
      rate: value.selling_price || rows[index].rate,
    };
  } else {
    updatedRow = { ...rows[index], [field]: value };
  }

  const quantity = parseFloat(updatedRow.quantity) || 0;
  const rate = parseFloat(updatedRow.rate) || 0;
  updatedRow.amount = (quantity * rate).toFixed(2);

  const updatedRows = [...rows];
  updatedRows[index] = updatedRow;

  console.log("🔹 Final updatedRows:", updatedRows);

  setRows(updatedRows);
  setselected_item_data(updatedRows);
  // list_data({ start: 0, search_input: '', disabled: 0,productlist:updatedRows.map(d => d.item_code) })
};

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    console.log("Item Added", rows);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    getItemdata(0, "");
  }, []);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;
    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getItemdata(newOffset, search_input);
      }
    };
    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  const [isAllSelectedd, setIsAllSelectedd] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({
    "Item Code": true,
    "Item Name": true,
    "category": true,
    "Sub category": true,
    "Quantity": true,
    "UOM": true,
    "Rate": true,
    "Amount": true,
  });
  const [showSettings, setShowSettings] = useState(false);

  const handleSelectAlll = (e) => {
    setIsAllSelectedd(e.target.checked);
  };

  const toggleColumn = (col) => {
    setColumnVisibility((prev) => ({ ...prev, [col]: !prev[col] }));
  };

  const columns = [
    "Action",
    "S.No",
    "Item Code",
    "Item Name",
    "category",
    "Sub category",
    "Quantity",
    "UOM",
    "Rate",
    "Amount",
    "Settings"
  ];

  const defaultWidths = {
    "Action": "20px",
    "S.No": "20px",
    "Item Code": "15%",
    "Item Name": "15%",
     "category":"15%",
    "Sub category":"15%",
    "Quantity": "7%",
    "UOM": "6%",
    "Rate": "10%",
    "Amount": "10%",
    "Settings": '4%'
  };

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {columns.map((title, i) => {
              if (title !== "Action" && title !== "S.No" && title !== "Settings" && !columnVisibility[title]) return null;

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: "center",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ backgroundColor: isAllSelected ? "#270b79" : "", borderColor: isAllSelected ? "#270b79" : "", fontSize: '15px' }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : title === "Settings" ? (
                    <div style={{ position: "relative" }}>
                      <span
                        style={{ cursor: "pointer", fontSize: "12px" }}
                        onClick={() => setShowSettings(!showSettings)}
                      >
                        ⚙️
                      </span>
                      {showSettings && (
                        <div style={{
                          position: "absolute",
                          top: "20px",
                          right: 0,
                          backgroundColor: "#f9f9f9",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          padding: "12px",
                          zIndex: 999,
                          width: "220px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          color: "#000"
                        }}>
                          <strong style={{ fontSize: "14px", display: "block", marginBottom: "10px" }}>
                            Toggle Columns
                          </strong>
                          <div style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            display: "flex",
                            flexDirection: "column",
                            gap: "6px",
                          }}>
                            {Object.keys(columnVisibility).map((col, idx) => (
                              <label key={idx} style={{ display: "flex", alignItems: "center", fontSize: "13px", text: 'black' }}>
                                <input
                                  type="checkbox"
                                  checked={columnVisibility[col]}
                                  onChange={() => toggleColumn(col)}
                                  style={{ marginRight: "8px", cursor: "pointer" }}
                                />
                                {col}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                {/* Action Checkbox - Always visible */}
                <td className="p-0" style={{ cursor: 'pointer', height: '30px' }}>
                  <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79', textAlign: 'center' }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                      </span>
                    )}
                  </p>
                </td>

                {/* S.No - Always visible */}
                <td style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  padding: '0.5rem',
                  height: '30px'
                }}>
                  {globalIndex + 1}
                </td>

                {/* Item Code - Conditionally visible */}
                {columnVisibility["Item Code"] && (
                  !fullData || fullData?.message?.status == "Draft" ? <td className="p-0 d-flex justify-content-center" style={{ position: "relative", border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'item_code' ? '0.3px solid #270b79' : '' }}>
                    <input
                      type="text"
                      className=" p-0 form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '28.4px', textAlign: 'center' }}
                      onFocus={() => {getItemdata(); setTimeout(() => { setShowDropdown(globalIndex); setFocusedCell({ rowIndex: globalIndex, field: 'item_code' }); }, 302) }}
                      onBlur={() => { setTimeout(() => { setShowDropdown(false); setFocusedCell({ rowIndex: null, field: null }); }, 300) }}
                      onChange={(e) => {
                        setsearch_input(e.target.value);
                        setOffset(0);
                        getItemdata(0, e.target.value);
                        updateRow(globalIndex, "item_code", e.target.value);
                      }}
                      onKeyDown={(e) => {
  if (showDropdown === globalIndex && item_list.length > 0) {
    if (e.key === "Enter") {
      e.preventDefault();
      const selectedItem = item_list[0]; // always first item

      updateRow(globalIndex, "item", {
        ...selectedItem,
        item_code: selectedItem.item_code,
        rate: selectedItem.selling_price || 0,
      });

      setsearch_input("");
      // setShowDropdown(false);
    }
  }
}}

                      value={
                        search_input !== "" && focusedCell.rowIndex === globalIndex
                          ? search_input : focusedCell.rowIndex === globalIndex && search_input === "" && row.item_code === ""
                            ? "" : (row.item.item_code || row.item_code)
                      }
                    />

                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: showDropdown === globalIndex ? "200px" : "0",
                        display: showDropdown === globalIndex ? '' : 'none',
                        overflowY: "auto",
                        background: "white",
                        border: showDropdown === globalIndex ? "1px solid #ccc" : "",
                        zIndex: 10,
                      }}
                    >
                      {item_list.map((item, idx) => (
                        <div key={idx}
                          className="text-start"
                          onClick={() => {
                              updateRow(globalIndex, "item", {
                                ...item,
                                item_code: item.item_code,
                                rate: item.buying_price || 0
                              });

                            
                            setsearch_input("");
                            setShowDropdown(false);
                          }}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <p className="m-0">
                            {item.item_code}
                          </p>
                          <div style={{ fontSize: '10px' }}>
                            {item?.item_name}, {item?.item_group}
                          </div>
                        </div>
                      ))}
                      {!hasMore && item_list.length === 0 && (
                        <div style={{ padding: "8px", color: "#888" }}>No results</div>
                      )}
                    </div>
                  </td> : <td className="p-0 d-flex justify-content-center" style={{ position: "relative" }}>
                    <input
                      type="text"
                      className=" p-0 form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '28.4px', textAlign: 'center' }}
                          value={(row.item.item_code || row.item_code)}
                    />
                  </td>
                )}

                {/* Item Name - Conditionally visible */}
                {columnVisibility["Item Name"] && (
                  <td className="p-0" style={{ height: '30px', textAlign: 'center' }}>
                    <input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }} readOnly value={row.item?.item_name || ""} />
                  </td>
                )}

                {/* Category */}
                {columnVisibility["category"] && (
                  <td className="p-0" style={{ height: '30px' }}>
                    <input
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }}
                      readOnly
                      value={row?.item?.category || row?.item?.custom_category }
                    />
                  </td>
                )}

                {/* Sub Category */}
                {columnVisibility["Sub category"] && (
                  <td className="p-0" style={{ height: '30px' }}>
                    <input
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }}
                      readOnly
                      value={row?.item?.subcategory || row?.item?.item_group }
                    />
                  </td>
                )}


                {/* Quantity - Conditionally visible */}
                {columnVisibility["Quantity"] && (
                 !fullData || fullData?.message?.status == "Draft" ? <td className="p-0"
                    onClick={() => setActiveIndex(globalIndex)}
                    style={{
                      height: '30px',
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'quantity' ? '1.6px solid #270b79' : ''
                    }}
                  >
                    <input
                      ref={el => quantityInputRefs.current[globalIndex] = el}
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }}
                      min={1}
                      value={row.quantity}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          updateRow(globalIndex, "quantity", value);
                        }
                      }}
                      onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'quantity' })}
                      onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                      onKeyDown={(e) => handleInputKeyDown(e, globalIndex, 'quantity', quantityInputRefs)}
                    />
                  </td> : <td className="p-0"
                    // onClick={() => setActiveIndex(globalIndex)}
                    style={{ height: '30px'  }}
                  >
                    <input
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }}
                      min={1}
                      value={row.quantity}
                     />
                  </td>
                )}


                {/* UOM - Conditionally visible */}
                {columnVisibility["UOM"] && (
                  <td className="p-0" style={{ height: '30px' }}>
                    <input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }} readOnly value={row.item?.stock_uom || ""} />
                  </td>
                )}

                {/* Rate - Conditionally visible and editable */}
                {columnVisibility["Rate"] && (
               !fullData || fullData?.message?.status == "Draft" ?  <td className="p-0"
                    style={{
                      height: '30px',
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'rate' ? '1.6px solid #270b79' : ''
                    }}
                  >
                    <input
                      ref={el => rateInputRefs.current[globalIndex] = el}
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }}
                      value={focusedCell.rowIndex === globalIndex && focusedCell.field === 'rate' ? row.rate : `₹${row.rate}`}
                      onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'rate' })}
                      onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                      onChange={(e) => {
                        const value = e.target.value.replace('₹', '');
                        if (/^\d*\.?\d*$/.test(value)) {
                          updateRow(globalIndex, "rate", value);
                        }
                      }}
                      onKeyDown={(e) => handleInputKeyDown(e, globalIndex, 'rate', rateInputRefs)}
                    />
                  </td> : <td className="p-0"style={{height: '30px'}}>
                    <input
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }}
                      value={`₹${row.rate}`}
                     
                     
                    />
                  </td>
                )}

                {/* Amount - Conditionally visible */}
                {columnVisibility["Amount"] && (
                  <td className="p-0" style={{ height: '30px' }}>
                    <input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem', height: '30px', textAlign: 'center' }} readOnly value={row.amount != "0.00" ? `₹${row.amount}` : ''} />
                  </td>
                )}

                {/* Settings - Always visible */}
                <td className="p-0" >
                  <span
                    onClick={() => openEditModal(row, globalIndex)}
                    style={{ cursor: 'pointer' }}
                  >
                    <GetIcon iconName="MdOutlineEdit" size={15} />
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {selectedRows.length > 0 && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn "
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}

          {selectedRows.length == 0 && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{ backgroundColor: '#ff8d5c', padding: '1px', display: 'flex' }}
            >
              Add Row
            </Button>
          )}

          {
            showEditModal &&
            <EditItemModal
              show={showEditModal}
              onClose={() => setShowEditModal(false)}
              itemDataReal={popdata}
              updateRow={updateRow}
            />
          }

          {rows.length > 0 && <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
            onClick={() => {
              handleDownloadCSV(
                [
                  "S.No",
                  "Item Code (Items)",
                  "Item Name (Items)",
                  "Category",
                  "Sub Category",
                  "Quantity (Items)",
                  "Rate (Items)",
                  "UOM (Items)",
                  "Amount"
                ],
                rows,
                "sales-order"
              );
            }}
          >
            Download
          </Button>}
        </div>

        {/* Pagination */}
        <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default EnhancedTable;